import { atom } from "jotai";

export const StockListPageAtom = atom(1);
export const StockListPageSizeAtom = atom(10);
